function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.323 12.5c-.184 0-.364-.048-.523-.14a1.176 1.176 0 01-.582-1.026V2.666c0-.43.223-.823.582-1.026a1.05 1.05 0 011.069.013l7.409 4.435a1.077 1.077 0 010 1.823l-7.41 4.436a1.06 1.06 0 01-.545.153z",
  fill: "currentColor"
});

var SvgStart = function SvgStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgStart;